import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_COLLECTIVITES } from '../../../config/aides-collectivites';

export default function CollectivitesAidesHubPage() {
  return (
    <AudienceAidesHub
      audienceId="collectivites"
      aides={AIDES_COLLECTIVITES}
      heroEyebrow="Panorama 2026 · 6 dispositifs"
      heroHeadline="Financements publics"
      heroHeadlineAccent="pour votre collectivité"
      heroIntro="Fonds vert, DETR/DSIL, CEE collectivités (ACTEE/SEQUOIA), prêts Banque des Territoires et Fonds chaleur ADEME : cinq dispositifs nationaux mobilisables et cumulables pour structurer le plan de financement de vos projets de transition énergétique."
      primaryCta={{
        label: 'Diagnostic CEE collectivités',
        href: '/collectivites/diagnostic-cee',
      }}
      secondaryCta={{
        label: 'Décret tertiaire · OPERAT',
        href: '/collectivites/decret-tertiaire',
      }}
      bullets={['Sources officielles citées', 'Conforme commande publique', 'Sans engagement']}
      gridEyebrow="6 dispositifs cumulables"
      gridTitle="Les financements mobilisables par les maîtres d'ouvrage publics"
      ctaFinalTitle="Quel cumul d'aides pour votre projet ?"
      ctaFinalDescription="On identifie les fiches CEE secteur BAT qui s'appliquent à votre patrimoine, on vérifie l'éligibilité Fonds vert, DETR et DSIL, et on structure votre plan de financement."
    />
  );
}
